import React, { useEffect, useRef, useState } from "react";
import {
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  TableContainer,
  makeStyles,
  Button,
} from "@material-ui/core";
import {
  useTable,
  useSortBy,
  useFilters,
  usePagination,
  useGlobalFilter,
} from "react-table";
import { IoArrowDown, IoArrowUp } from "react-icons/io5";
import { COLUMNS } from "./Column";
import baseUrl from "../../api/baseUrl";
import "../../styles/table.css";
import TableHeaderAction from "./TableHeaderAction";
import { setDateRange, setStatusFilterValue } from "../../actions";
import { connect } from "react-redux";
import AdminAuth from "../../utility/auth";
import { Fab } from "@mui/material";
import { BiPlus } from "react-icons/bi";
import OrderDetail from "../userData/Orderdetails";

const AgentTable = (props) => {
  const csvDataRef = useRef([]);
  const useStyles = makeStyles({
    container: {
      minHeight: 250,
      maxHeight: 650,
    },
  });
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [clickedRow, setClickedRow] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState("");
  // const [dateRange, setDateRange] = useState(null);
  const [PageCount, setPageCount] = useState(-1);

  function reset() {
    console.log("dd");
    setData([]);
    setSearchText("");
    setDateRange(null);
    fetchData();
    setPagination({ pageIndex: 0, pageSize: 10 });
    setPageCount(-1);
    csvDataRef.current = [];
  }

  const fetchData = async (page, limit = 10) => {
    setLoading(true);
    try {
      const res = await baseUrl.get(`/listAgents`);
      if (res.data.isSuccess) {
        setLoading(false);
        setData(res.data.data);
      }
      console.log(res.data);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const renderToggleIcon = (column) => {
    if (column.isSorted) {
      if (column.isSortedDesc) {
        return (
          <IoArrowDown
            color="#fff"
            onClick={() => column.toggleSortBy(false)}
          />
        );
      } else {
        return (
          <IoArrowUp color="#fff" onClick={() => column.toggleSortBy(true)} />
        );
      }
    } else {
      return;
    }
  };
  const {
    getTableProps,
    page,
    rows,
    state,
    setGlobalFilter,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    setFilter,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
  } = useTable(
    {
      columns: COLUMNS,
      data,
      initialState: {
        sortBy: [
          {
            id: "createdAt",
            desc: true,
          },
        ],
        pageSize: 10,
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { globalFilter, pageIndex, pageSize } = state;
  useEffect(() => {
    // props.em.addListener("onVehicleRefresh", reset);
    AdminAuth.getInstance().eventEmitter.addListener(
      "refreshAgentData",
      fetchData
    );
  }, []);
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    // if (searchText || dateRange) {
    //   fetchData();
    // }
  }, []);

  const createRowsFromFilter = (row) => {
    csvDataRef.current.push(row.values);
    prepareRow(row);
    return (
      <TableRow
        hover
        onClick={() => {
          setOpen(true);
          setClickedRow(row);
        }}
        {...row.getRowProps()}
      >
        {row.cells.map((cell) => {
          return (
            <TableCell {...cell.getCellProps()}>
              {cell.render("Cell")}
            </TableCell>
          );
        })}
      </TableRow>
    );
  };

  return (
    <>
      <div className="table__wrap">
        <div>
          <Fab
            style={{
              margin: 0,
              top: "auto",
              right: 40,
              bottom: 30,
              left: "auto",
              position: "fixed",
              borderRadius: "50%",
            }}
            color="default"
            aria-label="add"
            onClick={props.addAgent}
          >
            <BiPlus size={30} />
          </Fab>
        </div>

        {/* <div
          className="table__header-action-container"
          // style={{ pointerEvents: "none" }}
        >
          <TableHeaderAction
            filter={globalFilter}
            setGlobalFilter={setGlobalFilter}
            setFilter={setFilter}
            setDateRangeFilter={props.setDateRange}
            setStatusFilterValue={props.setStatusFilterValue}
            fetchOrdersData={fetchData}
            reset={fetchData}
          />
        </div> */}
        {data && data.length > 0 && !loading ? (
          <TableContainer
            style={{ height: "90% !important" }}
            className={classes.container}
          >
            <Table stickyHeader className="table" {...getTableProps()}>
              <TableHead>
                {headerGroups.map((headerGroup) => {
                  return (
                    <TableRow
                      className="table__header-row"
                      {...headerGroup.getHeaderGroupProps()}
                    >
                      {headerGroup.headers.map((column, i) => {
                        return (
                          <TableCell key={i} {...column.getHeaderProps()}>
                            {column.render("Header")}
                            <span>{renderToggleIcon(column)}</span>
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableHead>
              <TableBody {...getTableBodyProps()}>
                {page.map((row) => {
                  return createRowsFromFilter(row);
                })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : null}

        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-around",
            alignItems: "center",
            margin: 0,
          }}
        >
          <Button
            onClick={previousPage}
            disabled={!canPreviousPage}
            variant="outlined"
          >
            Prev
          </Button>
          <div>
            <p>
              {pageIndex + 1} of {pageOptions.length}
            </p>
          </div>
          <Button
            style={{
              fontWeight: "600",
            }}
            onClick={nextPage}
            disabled={!canNextPage}
            variant="outlined"
          >
            Next
          </Button>
        </div>
        {data[0] && clickedRow && (
          <OrderDetail row={clickedRow} open={open} setOpen={setOpen} />
        )}
      </div>
    </>
  );
};

export default connect(null, {
  setStatusFilterValue,
  setDateRange,
})(AgentTable);
